import { useCookies } from 'react-cookie';
import { customAlphabet } from 'nanoid';

const cookieDomainNameMap: { [key: string]: string } = {
  'https://cf-wordpress-webserver.com:8080': '.cf-wordpress-webserver.com',
  'https://staging.creativefabrica.com': '.creativefabrica.com',
  'https://www.creativefabrica.com': '.creativefabrica.com',
};

export const getMainDomain = () => cookieDomainNameMap[''];

export const DEVICE_ID_COOKIE_NAME = 'cfDeviceId';
export const DEVICE_ID_NOT_SET = '__notSet__';

const DEVICE_ID_ALLOWED_CHARS = '0123456789abcdefghijklmnopqrstuvwxyz';

export const useDeviceId = () => {
  const [cookies, setCookie] = useCookies([DEVICE_ID_COOKIE_NAME]);

  const deviceId = cookies[DEVICE_ID_COOKIE_NAME] || DEVICE_ID_NOT_SET;

  const generateDeviceId = () => {
    const nanoid = customAlphabet(DEVICE_ID_ALLOWED_CHARS, 10);
    const newDeviceId = nanoid();

    setCookie(DEVICE_ID_COOKIE_NAME, newDeviceId, {
      path: '/',
      expires: new Date(Date.now() + 1000 * 60 * 60 * 24 * 365 * 10), // 10 years
      domain: getMainDomain(),
    });

    return newDeviceId;
  };

  return { deviceId, generateDeviceId };
};
